enum NodeRuleActions {
  AssignStepToActor = 0
}

export default NodeRuleActions;
